'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _simpleParallaxJs = require('simple-parallax-js');

var _simpleParallaxJs2 = _interopRequireDefault(_simpleParallaxJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Shopwallpaper = {
	init: function init() {
		var image = document.getElementsByClassName('parallax');
		new _simpleParallaxJs2.default(image);
	}
};

exports.default = Shopwallpaper;